export { default as Img200 } from './processed/200/Secret-City-S2.jpg';
export { default as Img400 } from './processed/400/Secret-City-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Secret-City-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Secret-City-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Secret-City-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      173,
      114,
      61
    ],
    "_population": 177,
    "_hsl": [
      0.07886904761904763,
      0.4786324786324786,
      0.45882352941176474
    ]
  },
  "LightVibrant": {
    "_rgb": [
      232,
      179,
      156
    ],
    "_population": 274,
    "_hsl": [
      0.050438596491228026,
      0.622950819672131,
      0.7607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      93,
      55,
      33
    ],
    "_population": 881,
    "_hsl": [
      0.061111111111111116,
      0.4761904761904761,
      0.24705882352941178
    ]
  },
  "Muted": {
    "_rgb": [
      168,
      111,
      95
    ],
    "_population": 206,
    "_hsl": [
      0.03652968036529681,
      0.2955465587044534,
      0.5156862745098039
    ]
  },
  "LightMuted": {
    "_rgb": [
      191,
      158,
      128
    ],
    "_population": 2437,
    "_hsl": [
      0.07936507936507937,
      0.3298429319371728,
      0.6254901960784314
    ]
  },
  "DarkMuted": {
    "_rgb": [
      48,
      57,
      81
    ],
    "_population": 1956,
    "_hsl": [
      0.6212121212121212,
      0.25581395348837205,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Secret-City-S2.js